import { render, staticRenderFns } from "./vip-protocol.vue?vue&type=template&id=1991c84c&"
import script from "./vip-protocol.vue?vue&type=script&lang=js&"
export * from "./vip-protocol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports